"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12.004 2C17.529 2 22.008 6.479 22.008 12.004C22.008 17.529 17.529 22.008 12.004 22.008C6.479 22.008 2 17.529 2 12.004C2 6.479 6.479 2 12.004 2ZM9 10H7V16H9V10ZM12.8444 10H11V16H12.9219V13.1043C12.9219 12.3402 13.0747 11.6004 14.0762 11.6004C15.0637 11.6004 15.0759 12.4738 15.0759 13.1527V16H17V12.789C17 11.2122 16.64 10 14.6914 10C13.7555 10 13.1277 10.4853 12.8711 10.9457H12.8444V10ZM8.00065 7C7.44671 7 7 7.44792 7 7.99984C7 8.55207 7.44671 9 8.00065 9C8.55233 9 9 8.55207 9 7.99984C9 7.44792 8.55233 7 8.00065 7Z"
  })];
};

exports.default = _default;